export default __webpack_public_path__ + "static/media/disco_logo.3f22216a.gif";